export default __webpack_public_path__ + "static/media/bitcoin2.9d51eb2b.svg";